import { COLLECTION_ID } from '../constants/routePathConstants';
import ThumbnailCardUI from './ThumbnailCardUI';
import stackedCards from '../assets/images/stackedCards.png';
import { useCollectionActions } from '../hooks/useCollectionActions';
import styles from './ThumbnailCardUI.module.scss';
import ThumbnailCardV2 from './ThumbnailCardV2';
import { Link } from 'react-router-dom';

export const ThumbnailCardCollection = ({
  originalData,
  data,
  size,
  fullWidth,
  onSelect,
  selected,
  to = COLLECTION_ID,
  hideFavourite,
  onEdit,
  onDelete,
  designV2,
  ...rest
}) => {
  const {
    favouriteLoading,
    onFavouriteToggle,
    onShare,
    onDelete: _onDelete,
  } = useCollectionActions({
    item: data,
  });

  const handleDelete = onDelete || _onDelete;

  if (to === COLLECTION_ID) {
    const params = new URLSearchParams(location.search);
    params.delete('search');
    params.delete('s');
    to += `?${params}`;
  }

  const countValue = data?.item_count || +originalData?.item_count;

  return designV2 ? (
    <ThumbnailCardV2
      onFavouriteChange={onFavouriteToggle(data)}
      onSelect={onSelect}
      selected={selected}
      isFavourite={data.is_favourite}
      hideFavourite={hideFavourite}
      favouriteLoading={favouriteLoading}
      id={data?.id}
      titleProps={{
        as: Link,
        to: to.replace(':id', data?.id),
      }}
      data={data}
      userCard
      name={data?.name}
      thumbnail={stackedCards}
      date={data.updated_at}
      showMenu
      showCheckbox
      isFavouriteIcon
      imageText={`${countValue} item${+countValue > 1 ? 's' : ''}`}
      onShare={onShare}
      onDelete={handleDelete}
      redirect={true}
      redirectTarget="_self"
      redirectURL={to.replace(':id', data?.id)?.toString()?.replace('?', '')}
      {...rest}
    />
  ) : (
    <ThumbnailCardUI
      key={data.id}
      id={data.id}
      to={to}
      thumbnail={stackedCards}
      name={data.name}
      isFavourite={data.is_favourite}
      favouriteLoading={favouriteLoading}
      date={data.updated_at}
      onShare={onShare}
      onFavouriteChange={onFavouriteToggle(data)}
      size={size}
      fullWidth={fullWidth}
      onSelect={onSelect}
      selected={selected}
      onDelete={handleDelete}
      hideFavourite={hideFavourite}
      imageText={`${countValue} item${countValue > 1 ? 's' : ''}`}
      actionsListClassName={styles.actionListSpaceBetween}
      showActionsText
      data={data}
      {...rest}
    />
  );
};